// extracted by mini-css-extract-plugin
export var indeterminate = "_2g-6";
export var md = "_2g-5";
export var semantic = "_2g-7";
export var sm = "_2g-4";
export var text = "_2g-8";
export var toggleControl = "_2g-0";
export var toggleInput = "_2g-1";
export var toggleSwitch = "_2g-2";
export var xs = "_2g-3";